export default __webpack_public_path__ + "static/Presse-e9b5a75d6a1eae266ad286afd22cd116.jpg";